import { FC } from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, NavPage } from '../page/Breadcrumbs';
import { PageSizer, SizerMode } from '../page/PageSizer';

interface EssHeaderProps {
  title: string;
  icon: FC<{ className?: string }>;
  breadcrumbs: NavPage[];
}

export const EssHeader: FC<EssHeaderProps> = ({ title, icon: Icon, breadcrumbs }) => {
  const navigate = useNavigate();

  return (
    <div className={'w-full bg-secondary-std border-primary-std border-b'}>
      <PageSizer mode={SizerMode.HEADER}>
        <Breadcrumbs pages={breadcrumbs} />
        <div className="flex items-center py-1.5 sm:py-0">
          <button onClick={() => navigate(-1)}>
            <FiChevronLeft className="w-8 h-8" />
          </button>
          <Icon className="w-8 h-8 ml-2 mr-4" />
          <p className="text-3xl font-semibold">{title}</p>
        </div>
      </PageSizer>
    </div>
  );
};
